import React, { useState } from 'react';
import { Button, Input, message } from 'antd';
import { CopyOutlined, CheckCircleFilled, DownOutlined, UpOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { TEhrStepsConfig } from 'types/ehrConnection';
import s from './s.module.less';

type Props = {
    config: TEhrStepsConfig;
    agentEmail: string;
};

const EhrStepGuide = ({ config, agentEmail }: Props) => {
    const [expandedIdx, setExpandedIdx] = useState<number | null>(() => {
        const emailStepIdx = config.steps.findIndex((step) => step.showEmail);
        return emailStepIdx !== -1 ? emailStepIdx : null;
    });

    const handleCopyEmail = () => {
        navigator.clipboard.writeText(agentEmail);
        message.success('Email copied to clipboard');
    };

    const toggleStep = (idx: number) => {
        setExpandedIdx(expandedIdx === idx ? null : idx);
    };

    return (
        <div className={s.guideList}>
            {config.steps.map((step, idx) => {
                const isOpen = expandedIdx === idx;
                const hasBody = !!step.content || step.showEmail || step.img;

                return (
                    <div key={idx} className={`${s.guideStep}${step.warning ? ` ${s.warning}` : ''}`}>
                        {hasBody ? (
                            <button type="button" className={s.guideHead} onClick={() => toggleStep(idx)}>
                                <div className={`${s.guideNum}${step.warning ? ` ${s.warning}` : ''}`}>
                                    {step.warning ? <ExclamationCircleFilled /> : idx + 1}
                                </div>
                                <div className={s.guideTitle}>{step.title}</div>
                                {isOpen ? <UpOutlined /> : <DownOutlined />}
                            </button>
                        ) : (
                            <div className={s.guideHeadNoExpand}>
                                <div className={s.guideNum}>
                                    <CheckCircleFilled />
                                </div>
                                <div className={s.guideTitle}>{step.title}</div>
                            </div>
                        )}
                        {isOpen && hasBody && (
                            <div className={s.guideBody}>
                                {step.content && <div>{step.content}</div>}
                                {step.showEmail && (
                                    <div className={s.guideEmailRow}>
                                        <Input value={agentEmail} readOnly className={s.guideEmailInput} />
                                        <Button icon={<CopyOutlined />} onClick={handleCopyEmail}>
                                            Copy
                                        </Button>
                                    </div>
                                )}
                                {(Array.isArray(step.img) ? step.img : [step.img]).filter(Boolean).map((src) => (
                                    <div key={src} className={s.guideImg}>
                                        <img src={src} alt={`Step ${idx + 1}`} />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
            {config.helpLink && (
                <a
                    className={s.helpLink}
                    href={config.helpLink.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {config.helpLink.label}
                </a>
            )}
        </div>
    );
};

export default EhrStepGuide;
